/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CsvConfigurationDto,
  CsvPlatformDetailsDto,
  CsvPlatformDetailsUpdateRequest,
  CustomerViewPreferencesDto,
  ImportCsvConfigurationsRequest,
  OrganisationSettingsDto,
  UserViewPreferencesDto,
  ViewPreferencesRequest,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiOrganisationSettingsController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-organisation-settings-controller
   * @name GetUserViewPreferences
   * @request POST:/api/v1/organisation-settings/user-preferences
   */
  getUserViewPreferences = (data: ViewPreferencesRequest, params: RequestParams = {}) =>
    this.http.request<UserViewPreferencesDto, any>({
      path: `/v1/organisation-settings/user-preferences`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getUserViewPreferencesPath = '/v1/organisation-settings/user-preferences'
  static getUserViewPreferencesMethod = 'POST'
  /**
   * No description
   *
   * @tags api-organisation-settings-controller
   * @name GetSupplierViewPreferences
   * @request POST:/api/v1/organisation-settings/supplier-preferences
   */
  getSupplierViewPreferences = (data: ViewPreferencesRequest, params: RequestParams = {}) =>
    this.http.request<CustomerViewPreferencesDto, any>({
      path: `/v1/organisation-settings/supplier-preferences`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getSupplierViewPreferencesPath = '/v1/organisation-settings/supplier-preferences'
  static getSupplierViewPreferencesMethod = 'POST'
  /**
   * No description
   *
   * @tags api-organisation-settings-controller
   * @name ImportCsvPlatformDetailsFromOtherEntity
   * @request POST:/api/v1/organisation-settings/csv-templates/other-entity/{otherEntityId}/import
   */
  importCsvPlatformDetailsFromOtherEntity = (
    otherEntityId: string,
    data: ImportCsvConfigurationsRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/organisation-settings/csv-templates/other-entity/${otherEntityId}/import`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static importCsvPlatformDetailsFromOtherEntityPath =
    '/v1/organisation-settings/csv-templates/other-entity/${otherEntityId}/import'
  static importCsvPlatformDetailsFromOtherEntityMethod = 'POST'
  /**
   * No description
   *
   * @tags api-organisation-settings-controller
   * @name CreateOrUpdateCsvPlatformDetails
   * @request POST:/api/v1/organisation-settings/csv-platform-details
   */
  createOrUpdateCsvPlatformDetails = (
    data: CsvPlatformDetailsUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<CsvPlatformDetailsDto, any>({
      path: `/v1/organisation-settings/csv-platform-details`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createOrUpdateCsvPlatformDetailsPath = '/v1/organisation-settings/csv-platform-details'
  static createOrUpdateCsvPlatformDetailsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-organisation-settings-controller
   * @name GetViewPreferences
   * @request GET:/api/v1/organisation-settings/view-preferences
   */
  getViewPreferences = (params: RequestParams = {}) =>
    this.http.request<CustomerViewPreferencesDto, any>({
      path: `/v1/organisation-settings/view-preferences`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getViewPreferencesPath = '/v1/organisation-settings/view-preferences'
  static getViewPreferencesMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-settings-controller
   * @name GetOrganisationSettings
   * @request GET:/api/v1/organisation-settings/internal-settings
   */
  getOrganisationSettings = (params: RequestParams = {}) =>
    this.http.request<OrganisationSettingsDto, any>({
      path: `/v1/organisation-settings/internal-settings`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getOrganisationSettingsPath = '/v1/organisation-settings/internal-settings'
  static getOrganisationSettingsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-settings-controller
   * @name GetOtherEntityCsvConfigurations
   * @request GET:/api/v1/organisation-settings/csv-platform-details/other-entity/{otherEntityId}/csv-configurations-list
   */
  getOtherEntityCsvConfigurations = (otherEntityId: string, params: RequestParams = {}) =>
    this.http.request<CsvConfigurationDto[], any>({
      path: `/v1/organisation-settings/csv-platform-details/other-entity/${otherEntityId}/csv-configurations-list`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getOtherEntityCsvConfigurationsPath =
    '/v1/organisation-settings/csv-platform-details/other-entity/${otherEntityId}/csv-configurations-list'
  static getOtherEntityCsvConfigurationsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-settings-controller
   * @name GetActiveCsvPlatformDetailsForOrganisation
   * @request GET:/api/v1/organisation-settings/csv-platform-details/active
   */
  getActiveCsvPlatformDetailsForOrganisation = (params: RequestParams = {}) =>
    this.http.request<CsvPlatformDetailsDto, any>({
      path: `/v1/organisation-settings/csv-platform-details/active`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getActiveCsvPlatformDetailsForOrganisationPath =
    '/v1/organisation-settings/csv-platform-details/active'
  static getActiveCsvPlatformDetailsForOrganisationMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-settings-controller
   * @name GetAvailableCsvExportFormats
   * @request GET:/api/v1/organisation-settings/csv-export-formats/available-formats
   */
  getAvailableCsvExportFormats = (params: RequestParams = {}) =>
    this.http.request<
      (
        | 'ADDISON'
        | 'BMD'
        | 'DATEV'
        | 'DIAMANT'
        | 'LEXWARE'
        | 'SESAM'
        | 'DATEV_WITHOUT_DUO'
        | 'TWINFIELD'
        | 'DEFAULT_CSV_EXPORT'
      )[],
      any
    >({
      path: `/v1/organisation-settings/csv-export-formats/available-formats`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAvailableCsvExportFormatsPath =
    '/v1/organisation-settings/csv-export-formats/available-formats'
  static getAvailableCsvExportFormatsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-settings-controller
   * @name DeleteActiveCsvPlatformDetailsForOrganisation
   * @request DELETE:/api/v1/organisation-settings/csv-platform-details/delete
   */
  deleteActiveCsvPlatformDetailsForOrganisation = (params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/organisation-settings/csv-platform-details/delete`,
      method: 'DELETE',
      ...params,
    })

  static deleteActiveCsvPlatformDetailsForOrganisationPath =
    '/v1/organisation-settings/csv-platform-details/delete'
  static deleteActiveCsvPlatformDetailsForOrganisationMethod = 'DELETE'
}
